const Contactus = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
      <defs>
        <clipPath id="a">
          <rect
            width="18"
            height="18"
            transform="translate(-0.374)"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g transform="translate(636 -4476)">
        <g transform="translate(-635.626 4476)">
          <g transform="translate(0.626 1)">
            <path
              d="M4.222,10.9a17.4,17.4,0,0,0,5.786,4.532,9.005,9.005,0,0,0,3.238.958c.078,0,.153.007.231.007a2.681,2.681,0,0,0,2.079-.894.074.074,0,0,0,.014-.017,8.754,8.754,0,0,1,.656-.68c.16-.153.323-.313.479-.476a1.64,1.64,0,0,0-.007-2.443L14.656,9.846a1.653,1.653,0,0,0-1.2-.55,1.708,1.708,0,0,0-1.21.547l-1.216,1.216c-.112-.065-.228-.122-.336-.177a4.2,4.2,0,0,1-.374-.2,12.873,12.873,0,0,1-3.075-2.8,7.413,7.413,0,0,1-1.04-1.658c.319-.289.618-.591.907-.887.1-.105.207-.211.313-.316A1.742,1.742,0,0,0,7.993,3.8a1.728,1.728,0,0,0-.564-1.223L6.417,1.559c-.119-.119-.231-.234-.347-.353C5.846.975,5.611.737,5.38.523A1.694,1.694,0,0,0,4.184,0a1.744,1.744,0,0,0-1.21.527L1.7,1.8A2.611,2.611,0,0,0,.926,3.469,6.288,6.288,0,0,0,1.4,6.187,15.813,15.813,0,0,0,4.222,10.9ZM1.755,3.54A1.8,1.8,0,0,1,2.3,2.385L3.559,1.121A.915.915,0,0,1,4.184.832a.868.868,0,0,1,.612.3c.228.211.442.431.673.666.116.119.234.238.353.36L6.834,3.166a.923.923,0,0,1,.319.635.923.923,0,0,1-.319.635c-.105.105-.211.214-.316.319-.316.319-.612.622-.938.911l-.017.017a.664.664,0,0,0-.17.754c0,.01.007.017.01.027A8,8,0,0,0,6.6,8.405a13.586,13.586,0,0,0,3.275,2.983,4.863,4.863,0,0,0,.448.245,4.2,4.2,0,0,1,.374.2l.037.02a.71.71,0,0,0,.33.085.721.721,0,0,0,.506-.231l1.271-1.271a.9.9,0,0,1,.622-.3.853.853,0,0,1,.6.3l2.049,2.045a.819.819,0,0,1-.01,1.281c-.143.153-.292.3-.452.452a9.784,9.784,0,0,0-.71.737,1.865,1.865,0,0,1-1.458.618c-.058,0-.119,0-.177-.007a8.181,8.181,0,0,1-2.929-.877,16.525,16.525,0,0,1-5.507-4.315A15.135,15.135,0,0,1,2.183,5.908,5.48,5.48,0,0,1,1.755,3.54Z"
              transform="translate(-0.912 0)"
              stroke="#000"
              strokeWidth="0.5"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Contactus;
